import { request } from "./apiClient";

// Lista todas as cartas-traço.
export const getCartaTraco = async () => {
    return await request("/api/cartaTraco");
};

// Lista as cartas-traço de uma obra.
export const getCartaTracoObra = async (idObra) => {
    return await request(`/api/cartaTraco/CartaTracoObra/${idObra}`);
};

// Cria uma carta-traço.
export const createCartaTraco = async (cartaTracoData) => {
    return await request("/api/cartaTraco", {
        method: 'POST',
        body: JSON.stringify(cartaTracoData)
    });
};

// Atualiza uma carta-traço por id.
export const updateCartaTraco = async (idCartaTraco, cartaTracoData) => {
    return request(`/api/cartaTraco/${idCartaTraco}`, {
        method: 'PUT',
        body: JSON.stringify(cartaTracoData)
    });
};

// Exclui uma carta-traço por id.
export const deleteCartaTraco = async (idCartaTraco) => {
    return await request(`/api/cartaTraco/${idCartaTraco}`, {
        method: 'DELETE'
    });
};